export default __webpack_public_path__ + "static/media/Beard_10_C3.59fcf680.svg";